<template>
  <div
    id="cartao_frente"
    style="
      margin-bottom: 10%;
      position: relative;
      width: 50%;
      height: auto;
      float: left;
      letter-spacing: -0.5px;
    "
  >
    <div class="cartao_layout cartao_frente">
      <div
        :class="
          cartaoFrente.lowCost === 'S' ? 'topo_cartao_lowcost' : 'topo_cartao'
        "
      >
        <img :src="logotipo" class="logo_unimed" />
        <img :src="imgSomosCoop" class="somos_coop" />
        <div style="clear: right"></div>
        <div class="unimed_produto" style="text-align: right">
          <span v-html="cartaoFrente.nomePlano"></span>
          <br />
          {{ cartaoFrente.tipoContratacaoDescricao }}
        </div>
        <div style="clear: both"></div>
      </div>
      <div class="divisao_branca"></div>

      <div class="box_dados_beneficiario">
        <img :src="imgQRcode" class="qrcode" />
        <div style="clear: right"></div>
        <ul class="dados_beneficiario" style="float: right; width: 270px">
          <li class="linha_1 title">
            {{ cartaoFrente.beneficiarioCartao }}
          </li>

          <li class="card-line" v-if="cartaoFrente.nomeSocialCartao">
            <table
              border="0"
              cellpadding="0"
              cellspacing="0"
              class="tabela_bnf"
            >
              <tfoot>
                <tr>
                  <td class="columns-11">Nome Social</td>
                </tr>
              </tfoot>
              <tbody>
                <tr>
                  <td style="font-size: 13px;">
                    {{ cartaoFrente.nomeSocialCartao }}
                  </td>
                </tr>
              </tbody>
            </table>
          </li>

          <li class="card-line">
            <table
              border="0"
              cellpadding="0"
              cellspacing="0"
              class="tabela_bnf"
            >
              <tfoot>
                <tr>
                  <td class="columns-11">Nome do Beneficiário</td>
                  <td class="columns-1">Atend.</td>
                </tr>
              </tfoot>
              <tbody>
                <tr>
                  <td style="font-size: 13px;">
                    {{ cartaoFrente.nomeBeneficiario }}
                  </td>
                  <td>{{ cartaoFrente.localAtendimentoId }}</td>
                </tr>
              </tbody>
            </table>
          </li>

          <li class="card-line">
            <table
              border="0"
              cellpadding="0"
              cellspacing="0"
              class="tabela_bnf"
            >
              <tfoot>
                <tr>
                  <td class="columns-4">Data de Nascimento</td>
                  <td class="columns-3">Acomodação</td>
                  <td class="columns-5">Cobertura Parcial Temporária</td>
                </tr>
              </tfoot>
              <tbody>
                <tr>
                  <td>{{ cartaoFrente.dataNascimento | formatDate }}</td>
                  <td>{{ cartaoFrente.acomodacaoDescricao }}</td>
                  <td>{{ cartaoFrente.cptDescricao }}</td>
                </tr>
              </tbody>
            </table>
          </li>
        </ul>

        <ul class="dados_beneficiario">
          <li class="card-line">
            <table
              border="0"
              cellpadding="0"
              cellspacing="0"
              class="tabela_bnf"
            >
              <tfoot>
                <tr>
                  <td class="columns-6">Contratante</td>
                  <td class="columns-5">Abrangência</td>
                  <td class="columns-1">Via</td>
                </tr>
              </tfoot>
              <tbody>
                <tr>
                  <td>{{ cartaoFrente.nomeEmpresaContratante }}</td>
                  <td>{{ cartaoFrente.abrangenciaDescricao }}</td>
                  <td>{{ cartaoFrente.viaDescricao }}</td>
                </tr>
              </tbody>
            </table>
          </li>

          <li class="card-line">
            <table
              border="0"
              cellpadding="0"
              cellspacing="0"
              class="tabela_bnf"
            >
              <tfoot>
                <tr>
                  <td class="columns-4">Plano</td>
                  <td class="columns-3">Vigência do Plano</td>
                  <td class="columns-3">Rede de Atendimento</td>
                  <td class="columns-2">Validade</td>
                </tr>
              </tfoot>
              <tbody>
                <tr>
                  <td>{{ cartaoFrente.tipoPlanoDescricao }}</td>
                  <td>{{ cartaoFrente.dataInicioVigencia | formatDate }}</td>
                  <td>{{ cartaoFrente.redeAtendimentoDescricao }}</td>
                  <td>{{ cartaoFrente.dataValidade | formatDate }}</td>
                </tr>
              </tbody>
            </table>
          </li>

          <li class="card-line">
            <table
              border="0"
              cellpadding="0"
              cellspacing="0"
              class="tabela_bnf"
            >
              <tfoot>
                <tr>
                  <td class="columns-12">Segmentação Assistencial do Plano</td>
                </tr>
              </tfoot>
              <tbody>
                <tr>
                  <td>{{ cartaoFrente.segmentacaoDescricao }}</td>
                </tr>
              </tbody>
            </table>
          </li>
        </ul>
        <div id="caixaMarcaDagua" v-if="cartaoInativo">
          <span id="span_texto">BENEFICIÁRIO INATIVO</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

import QRcode from "@/assets/cartao_qrcode.png";
import SomosCoop from "@/assets/somos_coop.png";

import { WEB_SERVICE } from "@/constants";

import { buscaDadosCartaoFrente } from "@/services/beneficiario";
import { getLogoCartao } from "@/services/movimentos";

const { mapMutations } = createNamespacedHelpers("portal");
const { mapGetters } = createNamespacedHelpers("beneficiario");

export default {
  name: "CartaoFrente",
  props: {
    beneficiarioCartao: String
  },
  data() {
    return {
      cartaoFrente: {},
      imgQRcode: QRcode,
      imgSomosCoop: SomosCoop,
      logotipo: "",
      cartaoInativo: null
    };
  },
  computed: {
    ...mapGetters(["getDadosBeneficiario"])
  },
  watch: {
    beneficiarioCartao: {
      handler() {
        this.buscaDadosCartaoFrente();
      }
    }
  },
  mounted() {
    this.buscaDadosCartaoFrente();
    this.getLogoCartao();
    this.checkBnfrioAtivo();
  },
  methods: {
    ...mapMutations(["setErrorToast", "setToast"]),
    checkBnfrioAtivo() {
      this.cartaoInativo = !this.getDadosBeneficiario.ativo;
    },
    async buscaDadosCartaoFrente() {
      this.checkBnfrioAtivo();
      this.$emit("cartao-frente", true);
      await buscaDadosCartaoFrente(this.beneficiarioCartao)
        .then(response => {
          this.cartaoFrente = response;
        })
        .catch(({ response }) => {
          const resultado = response?.data?.message?.split("|");

          if (WEB_SERVICE.includes(resultado[0])) {
            this.setErrorToast(response?.data?.message);
          } else {
            this.setToast(
              response.data ? response.data.message : response.message
            );
          }
        })
        .finally(() => {
          this.$emit("cartao-frente", false);
        });
    },
    getLogoCartao() {
      getLogoCartao().then(response => {
        if (response && response.size !== 0) {
          var reader = new window.FileReader();

          reader.onload = () => {
            this.logotipo = reader.result;
          };

          reader.readAsDataURL(response);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/cartao-beneficiario.scss";
#caixaMarcaDagua {
  width: 100%;
  position: absolute;
  top: 169px;
  left: 0;
  height: 42px;
  z-index: -1;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  background: #c3c3c3;
  box-shadow: 3px 4px 4px 0px rgb(0 0 0 / 12%), 0px 2px 4px 0px rgb(0 0 0 / 64%);
}

#span_texto {
  top: 12px;
  position: absolute;
  color: black;
  text-align: center;
  font-weight: bold;
  height: 22px;
  left: 114px;
  padding-top: 3px;
  border-radius: 5px;
  opacity: 0.7;
  width: 152px;
}
</style>
